// extracted by mini-css-extract-plugin
export var standaloneTable = "_it-0";
export var standaloneTableWithBodyFill = "_it-1";
export var withExtraHeader = "_it-2";